<template lang="html">
  <v-container>
    <Welcomebar></Welcomebar>

    <v-row
    :class=" userIsAuthenticated ? 'my-12 py-12' : null "
    >
      <v-col class="d-flex align-center  justify-center  text-center ml-l-n12 mr-12">
        <p class="font-weight-thin  display-3">
          Welcome to Whist, the social network that values your privacy
        </p>
        <br>
      </v-col>

      <v-col class="pa-0">
        <Signup v-if="!userIsAuthenticated" class="signup"></Signup>

        <!-- getting started -->
        <v-card
        class="mx-l-12 px-l-12"
        max-width="500"
        flat
        v-if="userIsAuthenticated"
        >
        <v-list>
          <v-subheader>Get Started</v-subheader>
          <v-list-item-group >
            <v-list-item
            v-for="(item, i) in items"
            :key="i"
            :to="item.route"
            >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>

  </v-col>

</v-row>

<!-- Team Button -->
<v-row class="my-n12 d-flex justify-center">
  <v-btn depressed text to="/about">
    Team
    <v-avatar tile size="128">
        <v-img src="@/assets/Epic.png"></v-img>
    </v-avatar>
    Page
  </v-btn>
</v-row>

</v-container>

</template>

<script>
import Welcomebar from '@/components/Frontend/WelcomeBar.vue'
import Signup from '@/components/User/Signup.vue'

export default {
  components: {
    Welcomebar,
    Signup,
  },
  computed: {
    userIsAuthenticated(){
      return this.$store.state.user !== null && this.$store.state.user !== undefined && this.$store.state.user !== {}
    }
  },
  data: () => ({
    item: 1,
    items: [
      { text: 'Change your profile', icon: 'mdi-account-circle', route: '/profile'},
      { text: 'Add people to your friends list', icon: 'supervisor_account', route: '/friends'},
      { text: 'Check out your feed', icon: 'widgets', route: '/feed'},
      { text: 'Message your friends', icon: 'mdi-message', route: '/friends' },
    ],
  }),
  mounted() {
    this.$store.dispatch('firebaseGetDMs')
    this.$store.dispatch('firebaseGetFriends')
    this.$store.dispatch('firebaseDeletePosts')
    this.$store.dispatch('firebaseGetGroupChat')
    this.$store.dispatch('firebaseGetNotifications')
  }
}
</script>

<style lang="css" scoped>
.signup {
  width: 500px;
}
</style>
